import type { TournamentFragment } from "@workspace/casino_core/fragments/TournamentFragment";
import dynamic from "next/dynamic";

const TournamentCardMobile = dynamic(() => import("./Mobile"));
const TournamentCardDesktop = dynamic(() => import("./Desktop"));

type Props = {
  device: "mobile" | "desktop";
  tournament?: TournamentFragment;
  cardWidth?: string;
  cardClassname?: string;
  page?: TournamentPageType;
  isCurrentTournaments?: boolean;
};

const TournamentCard: FC<Props> = ({
  device,
  tournament,
  cardWidth,
  cardClassname,
  page,
  isCurrentTournaments,
}) => {
  if (device === "mobile") {
    return (
      <TournamentCardMobile
        tournament={tournament}
        cardWidth={cardWidth}
        page={page}
        isCurrentTournaments={isCurrentTournaments}
      />
    );
  }
  return (
    <TournamentCardDesktop
      tournament={tournament}
      cardClassname={cardClassname}
      page={page}
    />
  );
};

export default TournamentCard;
